/* eslint-disable no-param-reassign */

import Vapi from 'vuex-rest-api';

const fetcherAdminLog = new Vapi({
  state: {
    fetcherAdminLogs: {
      // Custom Log Levels
      queueLog: [],
      jobLog: [],
      creatorLog: [],
      postLog: [],
      channelLog: [],
      tagLog: [],
      madLog: [],
      messengerLog: [],
      reportLog: [],
      summaryLog: [],

      // Internal Log Levels
      emergencyLog: [],
      alertLog: [],
      criticalLog: [],
      errorLog: [],
      warningLog: [],
      noticeLog: [],
      infoLog: [],
      debugLog: [],
    },
  },
})
  .get({
    action: 'getFetcherAdminLog',
    path: ({ channel }) => `/api/fetcher/admin/logs?channel=${channel}`,
    onSuccess: (state, payload, axios, { params }) => {
      state.fetcherAdminLogs[params.channel] = payload.data;
    },
  })
  .get({
    action: 'getFetcherAdminLogs',
    property: 'fetcherAdminLogs',
    path: () => '/api/fetcher/admin/logs',
  })
  .getStore();

const mutations = {
  appendToLog: (state, payload) => {
    // console.log(payload);
    state.fetcherAdminLogs[payload.channel].push(payload);
  },
  populateLog: (state, payload) => {
    // console.log(payload);
    state.fetcherAdminLogs[payload.channel] = payload;
  },
  clearLog: (state, payload) => {
    // console.log(payload);
    state.fetcherAdminLogs[payload.channel] = [];
  },
};

const actions = {
  appendToLog({ commit }, payload) {
    commit('appendToLog', payload);
  },
  populateLog({ commit }, payload) {
    commit('populateLog', payload);
  },
  clearLog({ commit }, payload) {
    commit('clearLog', payload);
  },
};

fetcherAdminLog.mutations = Object.assign(fetcherAdminLog.mutations, mutations);
fetcherAdminLog.actions = Object.assign(fetcherAdminLog.actions, actions);

export default fetcherAdminLog;
